import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const grantAnalytics = () => {
  try { if (typeof window.gtag === "function") window.gtag("consent", "update", { analytics_storage: "granted" }); } catch {}
};

// Extra head scripts from /admin/scripts, only after the visitor accepted all cookies
const loadAdminScripts = async () => {
  if (window.__spAdminScripts) return;
  window.__spAdminScripts = true;
  try {
    const res = await fetch("/api/public/scripts");
    const { head } = await res.json();
    if (!head) return;
    const el = document.createElement("div");
    el.innerHTML = head;
    el.querySelectorAll("script").forEach((s) => {
      const ns = document.createElement("script");
      if (s.src) ns.src = s.src; else ns.textContent = s.textContent;
      document.head.appendChild(ns);
    });
  } catch {}
};

export default function CookieConsent() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("sp_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === "all") { grantAnalytics(); loadAdminScripts(); }
  }, []);

  const accept = (type) => {
    localStorage.setItem("sp_cookie_consent", type);
    setVisible(false);
    if (type === "all") { grantAnalytics(); loadAdminScripts(); }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-slide-up" data-testid="cookie-consent">
      <div className="max-w-3xl mx-auto bg-slate-900 border border-slate-800 rounded-xl shadow-2xl shadow-black/20 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-5 h-5 text-blue-400 shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-slate-300 leading-relaxed">
            {t("cookie.text")}{" "}
            <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline">Privacy Policy</Link>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="ghost" size="sm" className="text-slate-400 hover:text-white text-xs h-8" onClick={() => accept("essential")} data-testid="cookie-essential">
            {t("cookie.essential")}
          </Button>
          <Button size="sm" className="bg-[#2CA8AC] hover:bg-[#248F92] text-xs h-8 px-4" onClick={() => accept("all")} data-testid="cookie-accept-all">
            {t("cookie.accept_all")}
          </Button>
        </div>
      </div>
    </div>
  );
}
